// extracted by mini-css-extract-plugin
export default {"loading":"style_loading__DU6fI","search":"style_search__gWU4T"};